import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_2 = {
  key: 0,
  class: "inline-flex items-center justify-center h-6 w-6 rounded-full bg-primary",
  role: "img",
  "aria-label": "Selected"
};
const _hoisted_3 = {
  key: 1,
  class: "h-6 w-6"
};
const _hoisted_4 = {
  class: "text-sm text-gray-600 mb-2 leading-snug px-4"
};
const _hoisted_5 = {
  key: 1,
  class: "mb-2 text-2xl font-medium py-3.5"
};
const _hoisted_6 = {
  key: 2,
  class: "text-xs text-gray-500 my-1"
};
const _hoisted_7 = {
  class: "text-sm text-gray-700 leading-relaxed space-y-1 flex-1 mb-5 text-left"
};
const _hoisted_8 = {
  class: "flex-1"
};
const _hoisted_9 = {
  key: 5,
  class: "mb-4"
};
const _hoisted_10 = {
  class: "relative w-full h-9 bg-gray-100 border border-gray-300 rounded-lg grid grid-cols-2 select-none",
  role: "tablist",
  "aria-label": "Billing period"
};
const _hoisted_11 = ["aria-selected"];
const _hoisted_12 = ["aria-selected"];
const _hoisted_13 = {
  key: 6,
  class: "mb-4"
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'PlanCard',
  props: {
    plan: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    billingPeriod: {
      type: String,
      default: 'monthly'
    },
    detailsOpen: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'change-period', 'toggle-details'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      openChat
    } = useSupportChat();

    // Get features from the MeStore
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);
    const props = __props;
    const emit = __emit;
    const price = computed(() => {
      if (props.plan.id === 'elite') return 'Custom Pricing';
      const value = props.billingPeriod === 'annually' ? props.plan.annualPrice : props.plan.monthlyPrice;
      return `$${value}`;
    });
    const annuallyLabel = computed(() => props.plan?.annualSavePercent ? `Annually (Save ${props.plan.annualSavePercent}%)` : 'Annually');
    const periodSuffix = computed(() => {
      if (props.plan.id === 'elite') return '';
      return ' seat / month';
    });
    const wrapperClasses = computed(() => ['relative border rounded-lg flex flex-col transition cursor-pointer', props.compact ? 'p-4' : 'p-6', props.selected ? 'elevation-2' : 'border-gray-200 hover:border-gray-300']);

    // Simulate a Vuetify "ring" using theme variables when selected
    const wrapperStyle = computed(() => {
      if (!props.selected) return {};
      return {
        outline: '1px solid rgb(var(--v-theme-success))',
        outlineOffset: '0px',
        borderColor: 'rgb(var(--v-theme-success))'
      };
    });
    function select() {
      emit('select');
    }
    const contact = () => {
      try {
        openChat();
      } catch (_) {
        // no-op
      }
      // Also emit select so parent can respond consistently
      emit('select');
    };
    function setPeriod(p) {
      emit('change-period', p);
    }
    function emitToggleDetails() {
      emit('toggle-details', props.plan.id);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([wrapperClasses.value, "text-center"]),
        style: _normalizeStyle(wrapperStyle.value),
        onClick: select
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", {
        class: _normalizeClass(["font-semibold flex-1 text-center", [__props.selected ? 'text-primary' : '', __props.compact ? 'text-2xl' : 'text-3xl']])
      }, _toDisplayString(__props.plan.name), 3), __props.selected ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
        class: "h-4 w-4",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        "stroke-width": "2.5"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M5 13l4 4L19 7"
      })], -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_3))]), _createElementVNode("p", _hoisted_4, _toDisplayString(__props.plan.tagline), 1), __props.plan.id !== 'elite' && !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['mb-2 font-bold', __props.compact ? 'text-2xl' : 'text-4xl', __props.selected ? 'text-primary' : ''])
      }, _toDisplayString(price.value), 3)) : __props.plan.id === 'elite' && !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Custom Pricing")) : _createCommentVNode("", true), __props.plan.id !== 'elite' && !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(periodSuffix.value), 1)])) : _createCommentVNode("", true), !__props.detailsOpen ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "text-xs text-gray-500 underline my-4 text-center",
        type: "button",
        onClick: _withModifiers(emitToggleDetails, ["stop"])
      }, " View Details ")) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.features, (f, i) => {
        return _openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex items-start gap-3",
          style: {
            "padding-left": "0rem"
          }
        }, [_cache[3] || (_cache[3] = _createElementVNode("svg", {
          class: "mt-1 h-4 w-4 text-primary flex-shrink-0",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M5 13l4 4L19 7"
        })], -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(f), 1)]);
      }), 128))], 512), [[_vShow, __props.detailsOpen]]), __props.detailsOpen ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "text-xs text-gray-500 underline my-4 text-center",
        type: "button",
        onClick: _withModifiers(emitToggleDetails, ["stop"])
      }, " Hide Details ")) : _createCommentVNode("", true), __props.plan.id !== 'elite' && !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "absolute top-0 left-0 h-full w-1/2 rounded-md bg-white shadow transition-transform duration-200",
        style: _normalizeStyle({
          transform: __props.billingPeriod === 'monthly' ? 'translateX(0)' : 'translateX(100%)'
        }),
        "aria-hidden": "true"
      }, null, 4), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["z-10 text-xs font-medium rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--v-theme-primary))] h-full px-3", __props.billingPeriod === 'monthly' ? 'text-primary' : 'text-gray-600']),
        role: "tab",
        "aria-selected": __props.billingPeriod === 'monthly',
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => setPeriod('monthly'), ["stop"]))
      }, " Monthly ", 10, _hoisted_11), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["z-10 text-xs font-medium rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--v-theme-primary))] h-full px-3", __props.billingPeriod === 'annually' ? 'text-primary' : 'text-gray-600']),
        role: "tab",
        "aria-selected": __props.billingPeriod === 'annually',
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => setPeriod('annually'), ["stop"]))
      }, _toDisplayString(annuallyLabel.value), 11, _hoisted_12)])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(LlSecondaryButton, {
        block: "",
        onBtnClick: _withModifiers(contact, ["stop"])
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("Contact Success Team", -1)]))]),
        _: 1
      })]))], 6);
    };
  }
};